import React, { useEffect, useState, useRef } from 'react';
import Popup from '../../assets/svg/chat-bot/Popup.svg';
import clockImgUrl from '../../assets/svg/chat-bot/Clock.svg';
import Logo from '../../assets/svg/chat-bot/Logo.svg';
import chatImgUrl from '../../assets/svg/chat-bot/Message.svg';
import micImgUrl from '../../assets/svg/chat-bot/Mic.svg';
import message from "../../assets/svg/chat-bot/SmallMessage.svg";
import Newchat from '../../assets/svg/chat-bot/NewChat.svg';
import Search from '../../assets/svg/chat-bot/Search.svg';
import close1 from "../../assets/svg/chat-bot/close.svg"
import history from "../../assets/svg/chat-bot/Clock.svg"
import enter from "../../assets/svg/chat-bot/enter-msg.svg"
import "./chatbot.css";
import axios from "axios";
import { getCookie } from "../getcookie.js";
import moment from "moment";
import speechStop from '../../assets/svg/chat-bot/audio-stop.svg';
import ChatGPTTypingEffect from './ChatGPTTyping.js';

export default function ChatBot({ onHide }) {
  const apiUrl = process.env.REACT_APP_MAI_API_URL;
  const endRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [answerLoading, setAnswerLoading] = useState(false);
  const [lastKey, setLastKey] = useState("");
  const [inputField, setInputField] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [isNewAnswer, setIsNewAnswer] = useState(false);
  const [conversationId, setConversationId] = useState(-1);
  const [showNewChat, setShowNewChat] = useState(true);






  const [chatConversation, setChatConversation] = useState([
    { welcome: 'welcome' },
  ]);
  const [conversationHistory, setConversationHistory] = useState([]);
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 10,
      bottom: 0,
      backgroundColor: "transparent",
      opacity: 1,
      display: "flex",
      justifyContent: "end",
      alignItems: "end",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      /*  padding: "16px 24px", */
      borderRadius: "24px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "400px",
      height: "475px",
      textAlign: "center",
      /*  overflowY: "auto", */
    },
  };
  const recognitionRef = useRef(null);
  let recognition = null;
  const initializeRecognition = () => {
    if (!("webkitSpeechRecognition" in window)) {
      alert("Your browser does not support Speech Recognition.");
      return null;
    }

    const recognitionInstance = new window.webkitSpeechRecognition();
    recognitionInstance.continuous = true;
    recognitionInstance.interimResults = true;
    recognitionInstance.lang = "en-US";

    recognitionInstance.onresult = (event) => {
      const transcript = Array.from(event.results)
        .map((result) => result[0].transcript)
        .join("");
      setInputField(transcript);
    };

    recognitionInstance.onend = () => {
      setIsListening(false);
    };

    return recognitionInstance;
  };

  const startListening = () => {
    setIsListening(true);
    if (!recognitionRef.current) {
      recognitionRef.current = initializeRecognition();
    }
    if (recognitionRef.current) {
      recognitionRef.current.start();
    }
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.onend = null; // Prevent auto-restart
      recognitionRef.current.stop();
      console.log("Stopped manually");
    }
    setIsListening(false);
  };

  const handleSubmitQuestion = () => {
    if (inputField !== "") {
      new Promise((resolve, reject) => {
        const tempConversation1 = [...chatConversation];
        const txt = inputField;
        tempConversation1.push({ question: txt, dateAt: new Date() })
        setChatConversation(tempConversation1);
        console.log(tempConversation1)
        setInputField('');
        submitQuestion(txt, tempConversation1);
        setTimeout(() => {
          endRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 500);
      });
    }
  }
  const submitQuestion = async (question, tempConversation) => {
    setLoading(true)
    setAnswerLoading(true);
    const response = null;
    try {
      if (conversationId === null || conversationId === undefined || conversationId === -1) {
        response = await axios.post(
          apiUrl + `conversation`,
          {
            "query": question,
            "application": "TickGo"
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization:
                getCookie("mawalog"),
            },
          }
        ).then((response) => {
          if (response.statusCode === 400) {
          } else {
            if (response.data.success === true) {
              setConversationId(response.data.id);
              setIsNewAnswer(true);
              console.log('before answer', chatConversation)

              tempConversation.push({ answer: response.data.answer })
              console.log('after answer', tempConversation)
              setChatConversation(tempConversation);
              setTimeout(() => {
                endRef.current?.scrollIntoView({ behavior: "smooth" });
              }, 500);
            }
          }
        })
          .catch((error) => {
            if (error.response) {
              console.error("Error Status:", error.response.status);
              console.error("Error Data:", error.response.data);
              if (error.response.status === 400) {
              }
              /*  const tempConversation=[...chatConversation]; 
               tempConversation.push({error:"Retry"})
               setChatConversation(tempConversation);      */
            } else {
              console.error("Request failed:", error.message);
            }
          });
      } else {
        await axios.put(
          apiUrl + `conversation/` + conversationId,
          {
            "query": question,
            "application": "TickGo"
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization:
                getCookie("mawalog"),
            },
          }
        ).then((response) => {
          if (response.statusCode === 400) {
          } else {
            if (response.data.success === true) {
              setConversationId(response.data.id);
              setIsNewAnswer(true);
              console.log('before answer', chatConversation)

              tempConversation.push({ answer: response.data.answer })
              console.log('after answer', tempConversation)
              setChatConversation(tempConversation);
              setTimeout(() => {
                endRef.current?.scrollIntoView({ behavior: "smooth" });
              }, 500);
            }
          }
        })
          .catch((error) => {
            if (error.response) {
              console.error("Error Status:", error.response.status);
              console.error("Error Data:", error.response.data);
              if (error.response.status === 400) {
              }
              /*  const tempConversation=[...chatConversation]; 
               tempConversation.push({error:"Retry"})
               setChatConversation(tempConversation);      */
            } else {
              console.error("Request failed:", error.message);
            }
          });
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setAnswerLoading(false);
      setLoading(false)
    }
  }
  const getConversationList = async (term) => {
    setLoading(true)
    setConversationHistory([])
    try {
      const response = await axios.get(apiUrl + `conversation`, {
        params: { search: term, limit: 10, skip: 0 },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: getCookie("mawalog"),
        },
      });

      if (response.data.success === true) {
        console.log("Happy Birthday to you");
        setConversationHistory(response.data.convos);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data.work);
        if (error.response.status === 400) {

        }
      }
    } finally {
      setLoading(false)
    }
  };

  const getConversation = async (id) => {
    setLoading(true)
    setIsNewAnswer(false);
    setChatConversation([]);
    try {
      const response = await axios.get(apiUrl + `conversation/` + id, {
        params: {},
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: getCookie("mawalog"),
        },
      });

      if (response.data.success === true) {
        console.log("Happy Birthday to you");
        const conversation = response.data.convo.chats ?? [];
        setConversationId(response.data.convo.id);
        const tempConversation = [];
        conversation.forEach((item, index) => {
          if (item.question != null && item.question !== "") {
            tempConversation.push({ question: item.question, dateAt: item.date })
          }
          if (item.answer != null && item.answer !== "") {
            tempConversation.push({ answer: item.answer, dateAt: item.date })
          }
        })
        setChatConversation(tempConversation);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data.work);
        if (error.response.status === 400) {

        }
      }
    } finally {
      setLoading(false)
    }
  };

  const TimeAgo = (timestamp) => {
    console.log(timestamp)
    console.log(moment(timestamp).fromNow())
    return <span>{moment(timestamp).fromNow() === 'a few seconds ago' ? 'Just now' : moment(timestamp).fromNow()}</span>;
  };

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div className='d-flex align-items-center justify-content-between' style={{ height: '54px', background: '#0F141D', borderRadius: '24px 24px 0px 0px' }}>
          <img src={Logo} style={{ marginLeft: '8px' }} alt='Logo' />
          <div className='d-flex align-items-center'>
            <div onClick={() => {
              setIsNewAnswer(false);
              setShowNewChat(false);
              getConversationList()
            }} className='d-flex align-items-center' style={{ cursor: 'pointer', width: '40px', height: '40px' }}>
              <img src={history} style={{ marginLeft: '8px' }} alt='history' />
            </div>
            <div onClick={onHide} className='d-flex align-items-center' style={{ cursor: 'pointer', width: '40px', height: '40px' }}>
              <img src={close1} style={{ cursor: 'pointer', marginLeft: '8px', }} alt='close' />
            </div>
          </div>
        </div>

        {/* Chat Start */}
        {showNewChat && (<div>
          <div className='d-flex flex-column  mt-2' style={{ gap: '12px', height: '330px', overflow: 'scroll', scrollbarWidth: "none", msOverflowStyle: "none", }}>
            {chatConversation.map((chat, index) => (
              <div>
                {chat.welcome && (
                  <div className='d-flex align-items-center' style={{ marginRight: '30px', }}>
                    <div className='d-flex align-items-center' style={{ width: '40px', height: '40px' }}>
                      <img src={chatImgUrl} style={{ marginLeft: '8px' }} alt='history' />
                    </div>
                    <div className='mx-2' >
                      <div style={{ width: 'fit-content', padding: '10px 12px', background: '#F2F2F2', color: '#091E42', fontSize: '13px', fontWeight: '400', borderRadius: '20px 20px 20px 4px', textAlign: 'left' }}>
                        Glad to have you here! How can we assist you today?
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>)}

                {chat.question && (
                  <div className='d-flex justify-content-end' style={{ marginLeft: '30px', marginRight: '8px' }}>
                    <div>
                      <div style={{ width: 'fit-content', padding: '10px 12px', background: '#EAF4FF', color: '#091E42', fontSize: '13px', fontWeight: '400', borderRadius: '20px 20px 4px 20px', textAlign: 'left' }}>
                        {chat.question}
                      </div>
                      <div>
                        <div className="mt-1 d-flex align-items-center justify-content-end" style={{ fontFamily: 'Satoshi', fontWeight: '400', fontSize: '12px', lineHeight: '16.2px', color: '#8790A1', textAlign: 'right' }}> {TimeAgo(chat.dateAt)} <div className='mx-2' style={{ width: '4px', height: '4px', borderRadius: '23px', background: '#D9D9D9' }}></div><span style={{ fontFamily: 'Satoshi', fontWeight: '700', fontSize: '12px', lineHeight: '16.2px', color: '#6929E2' }}>You</span></div>
                      </div>
                    </div>
                  </div>)}
                {chat.answer && (
                  <div className='d-flex align-items-start' style={{ marginRight: '30px', }}>
                    <div className='d-flex align-items-center' style={{ width: '40px', height: '40px', marginTop: '10px', }}>
                      <img src={chatImgUrl} style={{ marginLeft: '8px' }} alt='history' />
                    </div>
                    <div className='mx-2 mt-2' >

                      {(chatConversation.length - 1 !== index || !isNewAnswer) && (<div style={{ whiteSpace: "pre-line", width: 'fit-content', padding: '10px 12px', background: '#F2F2F2', color: '#091E42', fontSize: '13px', fontWeight: '400', borderRadius: '20px 20px 20px 4px', textAlign: 'left' }}>
                        {chat.answer}
                      </div>)}
                      {chatConversation.length - 1 === index && isNewAnswer && (<ChatGPTTypingEffect text={chat.answer} />)}
                      <div>

                      </div>
                    </div>
                  </div>)}
                {chatConversation.length - 1 === index && answerLoading && (
                  <div className='d-flex align-items-center' style={{ marginRight: '30px', }}>
                    <div className='d-flex align-items-center' style={{ width: '40px', height: '40px' }}>
                      <img src={chatImgUrl} style={{ marginLeft: '8px' }} alt='history' />
                    </div>
                    <div className='mx-2' >
                      <div className="loader">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>)}
              </div>))}
            <div ref={endRef} />

          </div>
          <div className='d-flex align-items-center w-100' style={{ borderTop: '0.6 solidrgb(85, 62, 62)', paddingTop: '16px' }}>
            <div className='w-100'>
              {!loading && (<div className='d-flex align-items-center justify-content-center'>
                <textarea value={inputField}
                  onChange={(event) => { setInputField(event.target.value); }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleSubmitQuestion();
                    }
                  }}
                  placeholder="What can I help you today..." style={{ height: "44px", overflow: "scroll", scrollbarWidth: "none", msOverflowStyle: "none", resize: "none", width: '80%', borderRadius: '16px', border: '0.8px solid #E5E5E5', backgroundColor: '#F7F8F9', fontWeight: '500', fontSize: '13px', color: '#21272C' }} className="px-3 py-2" />
                {/*         <input type="text" multiple={2}  value={inputField} 
        onChange={(event) => { setInputField(event.target.value); }}
        onKeyDown={(event) => { 
          if(event.key==="Enter"){
           handleSubmitQuestion(); 
        }                                                                    
          }}
        placeholder="What can I help you today..." style={{ width: '80%', borderRadius: '100px', border: '0.8px solid #E5E5E5', backgroundColor: '#F7F8F9', fontWeight: '500', fontSize: '14px', color: '#21272C' }} className="px-3 py-2" />  */}
                {!inputField && !isListening && (<img src={micImgUrl} onClick={() => { startListening() }} disabled={isListening} style={{ cursor: 'pointer', marginLeft: '8px' }} width={'40px'} height={'40px'} alt='audio' />)}
                {isListening && (<img src={speechStop} onClick={() => { stopListening() }} disabled={!isListening} style={{ cursor: 'pointer', marginLeft: '8px' }} width={'40px'} height={'40px'} alt='audio' />)}
                {inputField && !isListening && (<img src={enter} onClick={() => { handleSubmitQuestion() }} style={{ cursor: 'pointer', marginLeft: '8px' }} width={'40px'} height={'40px'} alt='enter' />)}
              </div>)}


              <div onClick={() => { window.open("https://www.mawalog.com", "_blank", "noopener,noreferrer"); }} className="mt-1" style={{ fontWeight: '400', fontSize: '11px', color: '#8790A1', textAlign: 'center' }}>For more details : <span style={{ color: '#017DFE', }}>www.mawalog.com</span></div>
            </div>
          </div>
        </div>)}
        {/* Chat End */}

        {/* Chat History Start */}
        {!showNewChat && (
          <div style={{ position: "relative", }}>
            <div className='w-100'>
              <div className='d-flex align-items-center w-100' style={{ height: '60px' }}>
                <div className='w-100' style={{ position: "relative", }}>
                  <input
                    type="text"
                    placeholder="Search conversations..."
                    onChange={(e) => getConversationList(e.target.value)}

                    style={{ width: '80%', paddingLeft: '30px', borderRadius: '100px', border: '0.8px solid #E5E5E5', backgroundColor: '#FFFFFF', fontWeight: '500', fontSize: '14px', color: '#21272C' }} className="py-2"
                  />
                  <img src={Search} style={{ position: "absolute", left: "12%", top: "50%", transform: "translateY(-50%)", color: "#888", }} alt='Logo' />
                </div>
              </div>
              <div className='d-flex flex-column' style={{ height: '330px', overflow: 'scroll', scrollbarWidth: "none", msOverflowStyle: "none", }}>
                {conversationHistory.map((chat, index) => (
                  <div onClick={() => {
                    setShowNewChat(true);
                    getConversation(chat.id);
                  }} className='d-flex align-items-center justify-content-start py-2 px-4' style={{ borderBottom: '0.6px solid #E5E5E5' }} >
                    <div className='d-flex align-items-center justify-content-center' style={{ cursor: 'pointer', width: '40px', height: '40px', borderRadius: '100px', border: '0.6px solid #E5E5E5' }}>
                      <img src={message} style={{ cursor: 'pointer', }} alt='message' />
                    </div>
                    <div style={{ marginLeft: '8px' }}>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#091E42', textAlign: 'left' }}>{chat.title ?? ''}</div>
                      <div style={{ fontSize: '12px', fontWeight: '400', color: '#8790A1', textAlign: 'left' }}>{chat.date ?? ''}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <img src={Newchat} onClick={() => {
              setShowNewChat(true);
              setChatConversation([])
              setTimeout(() => {
                setChatConversation([{ welcome: 'welcome' }])
              }, 500);
            }} style={{ position: "absolute", right: "5%", bottom: "5%", transform: "translateY(-50%)", color: "#888", }} alt='Logo' />
          </div>)}
        {/* Chat History End */}
      </div>
    </div>
  );
}